var map = {
	"./arrow-double-next.svg": 145,
	"./arrow-double-prev.svg": 146,
	"./arrow-down.svg": 147,
	"./arrow-next.svg": 148,
	"./arrow-prev.svg": 149,
	"./arrow-up.svg": 150,
	"./close.svg": 151,
	"./cog.svg": 152,
	"./download.svg": 153,
	"./instagram.svg": 154,
	"./pencil.svg": 155,
	"./post1-template.svg": 156,
	"./post2-template.svg": 157,
	"./spotify.svg": 158,
	"./trash.svg": 159,
	"./trophy.svg": 160,
	"./video-template.svg": 161,
	"./youtube.svg": 162
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 144;